import { useDictionary } from '@/shared/lib/i18n';
import { Checkbox } from '@recruit-robin/robin-theme/web-components';
import { useNylasCalendarDontShowAgain, useNylasCalendarSetDontShowAgain } from '../../lib';

type DontShowAgainProps = {
  label?: string;
};

export const DontShowAgain = ({ label }: DontShowAgainProps = {}) => {
  const dictionary = useDictionary();
  const dontShowAgain = useNylasCalendarDontShowAgain();
  const setDontShowAgain = useNylasCalendarSetDontShowAgain();

  return (
    <Checkbox
      checked={dontShowAgain}
      onClick={() => setDontShowAgain(!dontShowAgain)}
      label={label ?? dictionary.dontShowThisAgain}
    />
  );
};
